"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transition = exports.AVAILABLE_TRANSITIONS = exports.GroupedTransition = void 0;
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var theme_1 = require("../../../mantine-theme/src");
var hooks_1 = require("../../../mantine-hooks/src");
var get_transition_styles_1 = require("./get-transition-styles/get-transition-styles");
var transitions_1 = require("./transitions");
var GroupedTransition_1 = require("./GroupedTransition");
Object.defineProperty(exports, "GroupedTransition", { enumerable: true, get: function () { return GroupedTransition_1.GroupedTransition; } });
exports.AVAILABLE_TRANSITIONS = Object.keys(transitions_1.transitions);
function Transition(_a) {
    var transition = _a.transition, _b = _a.duration, duration = _b === void 0 ? 250 : _b, mounted = _a.mounted, children = _a.children, themeOverride = _a.themeOverride, timingFunction = _a.timingFunction, onExit = _a.onExit, onEntered = _a.onEntered, onEnter = _a.onEnter, onExited = _a.onExited;
    var theme = theme_1.useMantineTheme(themeOverride);
    var reduceMotion = hooks_1.useReducedMotion();
    return (react_1.default.createElement(react_transition_group_1.Transition, { in: mounted, timeout: duration, unmountOnExit: true, mountOnEnter: true, onEnter: function (node) {
            node.offsetHeight;
            typeof onEnter === 'function' && onEnter();
        }, onExited: onExited, onEntered: onEntered, onExit: onExit }, function (transitionState) {
        return children(get_transition_styles_1.getTransitionStyles({
            transition: transition,
            duration: reduceMotion ? 0 : duration,
            state: transitionState,
            timingFunction: timingFunction || theme.transitionTimingFunction,
        }));
    }));
}
exports.Transition = Transition;
Transition.displayName = '@mantine/core/Transition';
